import axios from 'axios'
import _ from 'lodash'
import { exists, dataWithPath } from '../common/utils'
import config from '../common/config'
import { transforms } from '../common/utils/urlTemplate'
import store from '../store'

var instance = axios.create({
  // baseURL: config.url.base,
  timeout: 30000,
  // withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

var instance2 = axios.create({
  baseURL: config.url.base,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

instance.interceptors.request.use(interceptorRequest)
instance2.interceptors.request.use(interceptorRequest2)

function interceptorRequest (opts) {
  if (!opts.noLoading) {
    let { text } = opts
    store.commit('updateNetLoadingStatus', { isLoading: true, text: text || '请稍后...' })
  }
  let { params, data } = opts
  // 原始参数
  opts.origin = {
    ...(_.isPlainObject(params) ? params : {}),
    ...(_.isPlainObject(data) ? data : {})
  }
  opts.originData = data
  opts.originUrl = opts.url
  opts.originParams = params
  if (/\?/.test(opts.url)) {
    opts.url = opts.url + '&access_token={accessToken}'
  } else {
    opts.url = opts.url + '?access_token={accessToken}'
  }
  opts.params = { ...opts.params, accessToken: store.state.user.info.accessToken }
  opts.url = transforms(opts.url, opts.params)
  return opts
}
function interceptorRequest2 (opts) {
  if (!opts.noLoading) {
    let { text } = opts
    store.commit('updateNetLoadingStatus', { isLoading: true, text: text || '请稍后...' })
  }
  let { params, data } = opts
  // 原始参数
  opts.origin = {
    ...(_.isPlainObject(params) ? params : {}),
    ...(_.isPlainObject(data) ? data : {})
  }
  opts.url = transforms(opts.url, opts.params)
  return opts
}
// Add a response interceptor
instance.interceptors.response.use(interceptorResponse, interceptorResponseError)
instance2.interceptors.response.use(interceptorResponse, interceptorResponseError)

function interceptorResponse (response) {
  const opts = response.config
  const params = response.config.origin
  if (!opts.noLoading) {
    store.commit('updateNetLoadingStatus', { isLoading: false })
  }

  // 处理非通用数据格式
  if (!_.isPlainObject(response.data) || !_.has(response.data, 'errCode')) {
    return {
      errCode: 0,
      data: response.data,
      params
    }
  }

  response.data.params = params
  if (response.data.errCode === 0) {
    // console.info(response.config.url, response.data)
    if (response.data.data) {
      return response.data
    } else {
      return response.data
    }
  } else {
    // 业务错误
    let result
    if (response.data) {
      result = response.data
    } else {
      result = {
        errCode: response.status || -1,
        errMsg: response.statusText || '网络异常'
      }
    }

    if (result.errMsg !== '缺少查询条件。' && result.errMsg !== '用户ID、身份证号码以及用户姓名与手机号码不能全为空。' && !opts.noLoading) {
      store.commit('showToast', { type: 'text', text: dataWithPath(result, 'errMsg') || '请稍后再试', loading: true })
    }
    return Promise.reject(result)
  }
}
function makeErrorResult (error) {
  let response = error instanceof Error ? error.response || error : error
  let result

  if (response.data) {
    result = response.data
  } else {
    result = {
      errCode: response.status || -1,
      errMsg: response.statusText || '网络异常'
    }
  }
  return [result, response]
}
function interceptorResponseError (error) {
  // Http错误
  const opts = error.config
  let [result, response] = makeErrorResult(error)
  result.params = response.config.origin
  if (!opts.noLoading) {
    store.commit('updateNetLoadingStatus', { isLoading: false })
  }
  if (dataWithPath(error, 'response.data.error') === 'invalid_token') {
    return store.dispatch('oauthToken').then(() => {
      return api.request({
        method: response.config.method,
        params: response.config.originParams,
        data: response.config.originData,
        url: response.config.originUrl,
        noLoading: opts.noLoading
      }, () => {
      })
    })
  } else {
    if (!opts.noLoading) {
      store.commit('showToast', { type: 'text', text: dataWithPath(result, 'errMsg') || '请稍后再试', loading: true })
    }
    return Promise.reject(result)
  }
}
const api = {
  request: (opts) => {
    if (!/^http/i.test(opts.url)) {
      if (!opts.baseURL && /^\//.test(opts.url)) {
        opts.url = config.url.base + opts.url
      }
    }
    // console.log(opts)
    return instance.request(opts)
  },
  get: function (url, params, opts) {
    opts = opts || {}
    opts.method = 'get'
    opts.url = url
    if (exists(params)) {
      opts.params = params
    }
    return this.request(opts)
  },

  delete: function (url, params, opts) {
    opts = opts || {}
    opts.method = 'delete'
    opts.url = url
    if (exists(params)) {
      opts.params = params
    }
    return this.request(opts)
  },

  post: function (url, data, opts) {
    // console.log(url, data, opts)
    opts = opts || {}
    opts.method = 'post'
    opts.url = url
    if (exists(data)) {
      opts.data = data
    }
    return this.request(opts)
  },
  post2: function (url, data, opts) {
    opts = opts || {}
    opts.method = 'post'
    opts.url = url
    if (exists(data)) {
      opts.data = data
    }
    delete opts.method
    return instance2.post(url, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },

  put: (url, data, opts) => {
    opts = opts || {}
    opts.method = 'put'
    opts.url = url
    if (exists(data)) {
      opts.data = data
    }
    return this.request(opts)
  },

  patch: (url, data, opts) => {
    opts = opts || {}
    opts.method = 'patch'
    opts.url = url
    if (exists(data)) {
      opts.data = data
    }
    return this.request(opts)
  },

  sendForm: (url, data, { method = 'POST', target = '_blank' } = {}) => {
    // POST提交
    var form = document.createElement('form')
    form.action = url
    form.method = method
    form.target = target

    const setFiled = (key, val) => {
      var input = document.createElement('input')
      input.type = 'hidden'
      input.name = key
      input.value = val
      form.appendChild(input)
    }

    for (var key in data) {
      setFiled(key, data[key])
    }

    document.body.appendChild(form)
    form.submit()
    document.body.removeChild(form)
  }
}

export default api
